import { Pipe, PipeTransform, inject } from '@angular/core';

import { NativePrice } from './native-price';
import { NativePriceFormatterService } from './native-price-formatter.service';

@Pipe({
    name: 'msNativePriceFormatter',
})
export class NativePriceFormatterPipe implements PipeTransform {
    private nativeFormatter = inject(NativePriceFormatterService);
    /**
     * Format an instance of NativePricewith NativePriceFormatter, according to the specified user format.
     *
     * @param  price - The input price of type `INativePrice` that needs to be converted.
     * @param  cutOff - limiting the decimal points to 2, only for EU odds.
     * @param  cutZero - Remove trailing 0, only for EU odds.
     * @param  maxDecimalPlaces - max decimal points for the formatted odds
     * @returns  - The formatted price string.
     */
    transform(
        price: NativePrice | string | number | null | undefined,
        cutOff: boolean = false,
        cutZero: boolean = false,
        maxDecimalPlaces: number = 3,
    ): string {
        return this.nativeFormatter.format(price, cutOff, cutZero, maxDecimalPlaces);
    }
}
